document.addEventListener('DOMContentLoaded', function () {

  /* =========================
     SIZE CHART POPUP SLIDER
  ========================== */

  const popup = document.getElementById('scPopup');
  const openBtn = document.getElementById('scOpen');
  const slider = document.getElementById('scSlider');

  if (popup && openBtn && slider) {

    document.body.appendChild(popup);

    const slides = slider.children;
    const total = slides.length;

    const prevBtn = document.getElementById('scPrev');
    const nextBtn = document.getElementById('scNext');

    let current = 0;

    function updateArrows() {

      if (total <= 1) {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'none';
        return;
      }

      prevBtn.style.display = current === 0 ? 'none' : 'flex';
      nextBtn.style.display = current === total - 1 ? 'none' : 'flex';
    }

    function goTo(index) {

      current = Math.max(0, Math.min(index, total - 1));

      slider.style.transform =
        'translateX(-' + (current * 100) + '%)';

      updateArrows();
    }

    function openPopup() {
      popup.classList.add('active');
      document.body.classList.add('sc-lock');
      goTo(0);
    }

    function closePopup() {
      popup.classList.remove('active');
      document.body.classList.remove('sc-lock');
    }

    openBtn.addEventListener('click', openPopup);

   popup.addEventListener('click', function (e) {
  if (e.target.closest('[data-sc-close]')) {
    closePopup();
  }
});

    prevBtn.addEventListener('click', function () {
      goTo(current - 1);
    });

    nextBtn.addEventListener('click', function () {
      goTo(current + 1);
    });

    document.addEventListener('keydown', function (e) {

      if (!popup.classList.contains('active')) return;

      if (e.key === 'Escape') {
        closePopup();
      }

      if (e.key === 'ArrowLeft') {
        goTo(current - 1);
      }

      if (e.key === 'ArrowRight') {
        goTo(current + 1);
      }

    });

    updateArrows();
  }


  /* =========================
     UPSELL FUNCTIONALITY
  ========================== */

  const wrapper = document.querySelector(".upsell-box");

  if (wrapper) {

    const checks = wrapper.querySelectorAll(".upsell-check");
    const btn =
document.querySelector(".upsell-add-btn");
    const totalText =
document.querySelector(".upsell-total");

    function formatMoney(cents){

return '₹ ' + (cents / 100).toFixed(2);

}

    function updateTotal(){

let total = 0;

checks.forEach(function(el){

if(!el.checked){
return;
}

const price =
parseInt(el.dataset.price) || 0;

const discount =
parseInt(el.dataset.discount) || 0;

const finalPrice =
Math.round(
price - ((price * discount)/100)
);

total += finalPrice;

});

if(totalText){

totalText.innerHTML =
formatMoney(total);

}

}


    /* VARIANT CHANGE */

    wrapper.querySelectorAll(".upsell-variant").forEach(select => {

      select.addEventListener("change", function () {

        const option = this.selectedOptions[0];
        const parent = this.closest(".upsell-item");

        const checkbox = parent.querySelector(".upsell-check");

const priceText = parent.querySelector(".price-text");

const oldPrice = parent.querySelector(".upsell-old-price");

const off = parent.querySelector(".upsell-off");

const image = parent.querySelector(".upsell-img");


const price =
parseInt(option.dataset.price);

const discount =
parseInt(option.dataset.discount) || 0;

const finalPrice =
Math.round(
price - ((price * discount) / 100)
);


/* update checkbox */

checkbox.dataset.id =
option.value;

checkbox.dataset.price =
price;

checkbox.dataset.discount =
discount;


/* update price */

priceText.innerHTML =
formatMoney(finalPrice);


/* update old price */

if(oldPrice){

oldPrice.innerHTML =
formatMoney(price);

}


/* update OFF */

if(off){

off.innerHTML =
discount + '% OFF';

}


/* update image */

if(option.dataset.image){

image.src =
option.dataset.image;

}

updateTotal();
      });

    });


    /* CHECKBOX CHANGE */

    checks.forEach(el => {
      el.addEventListener("change", updateTotal);
    });


    /* ADD TO CART */

    btn.addEventListener("click", async function () {

      const selected =
        [...checks].filter(el => el.checked);

      if (!selected.length) {
        alert("Please select product");
        return;
      }

      btn.disabled = true;

      try {

        const items = selected.map(el => ({
          id: Number(el.dataset.id),
          quantity: 1
        }));

        await fetch("/cart/add.js", {

method:"POST",

headers:{

"Content-Type":"application/json",

"Accept":"application/json"

},

body:JSON.stringify({

items

})

});

const cartDrawer =
document.querySelector(
'cart-drawer'
);

if(cartDrawer){

const response =
await fetch(

'/?section_id=cart-drawer'

);

const html =
await response.text();

const parser =
new DOMParser();

const doc =
parser.parseFromString(

html,

'text/html'

);

const newDrawer =
doc.querySelector(

'cart-drawer'

);

if(newDrawer){

cartDrawer.innerHTML =
newDrawer.innerHTML;

}


/* remove empty state */

cartDrawer.classList.remove(
'is-empty'
);

const drawerItems =
cartDrawer.querySelector(
'cart-drawer-items'
);

if(drawerItems){

drawerItems.classList.remove(
'is-empty'
);

}


/* open drawer */

cartDrawer.classList.add(
'active'
);

document.body.classList.add(
'overflow-hidden'
);

}
      } catch (error) {

        console.log(error);

      }

      btn.disabled = false;

    });

    updateTotal();

  }

}); 



